<template lang="pug">
nav(aria-label="breadcrumb")
  ul.breadcrumb
    li.breadcrumb-item
      NuxtLink(
        to="/blog"
      ) Blog
      |
      IconChevronRight.divider(
        alt="Divider"
      )
    |
    li.breadcrumb-item(v-if="filterQuery")
      NuxtLink(
        :to="{ path: `/blog`, query: { ...route.query } }"
      ) {{ filterQuery }}
      |
      IconChevronRight.divider(
        alt="Divider"
      )
    |
    li.breadcrumb-item(
      v-for="(breadcrumb, index) in breadcrumbsLastItem"
      :key="index"
      :class="{ active: breadcrumb.active }"
    )
      NuxtLink(
        v-if="!breadcrumb.active"
        :to="breadcrumb.to"
      ) {{ breadcrumb.text }}
      |
      span(v-else) {{ breadcrumb.text }}
      |
      IconChevronRight.divider(
        v-if="!breadcrumb.active"
        alt="Divider"
      )
</template>

<script setup lang="ts">
import { IconChevronRight } from '@tabler/icons-vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const breadcrumbsLastItem = computed(() => {
  const pathArray = route.path.split('/').filter(Boolean);

  const breadcrumbList = pathArray.map((path, index) => {
    const to = '/' + pathArray.slice(0, index + 1).join('/');
    const text = path.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

    return {
      to,
      text,
      active: index === pathArray.length - 1,
    };
  });

  return [breadcrumbList[breadcrumbList.length-1]];
});

interface IProps {
  filterQuery?: string | undefined;
}

const props = withDefaults(defineProps<IProps>(), {
  filterQuery: "",
});
</script>

<style lang="sass" scoped>
nav
  margin-top: 20px
  margin-bottom: 4px
  color: var(--tealgreen-800, #074033)
  grid-column-start: 1
  grid-column-end: 13

  ul.breadcrumb
    display: flex
    list-style: none
    padding: 0
    margin: 0
    font-size: 14px
    font-style: normal
    font-weight: 500
    line-height: 20px
    margin: 0

  .breadcrumb-item
    display: flex
    align-items: center
    margin-right: 4px

    a
      text-decoration: none
      font-weight: 400

    .divider
      margin: 0
      margin-left: 4px
      width: 20px
      height: 26px

    &.active .divider
      display: none

    &.active
      pointer-events: none

@media (max-width: 768px)
  nav
    ul.breadcrumb
      flex-direction: column

    .breadcrumb-item
      text-align: left
      padding: 4px 0
</style>